import '../vendor';
import '../general/ofi';
import './oneevent/accordeon';


// WEBPACK FOOTER //
// ./src/js/pages/oneevent.js